/**
 * CUSTOMER-R4.9 — NBU UCT QR graphic from the public pay-page SVG endpoint.
 */
import type { StoreV2Lang } from "./store-v2-locale.js";

export function IbanPaymentQrV2({
  lang,
  publicUrl,
}: {
  lang: StoreV2Lang;
  publicUrl: string | null | undefined;
}) {
  const src = String(publicUrl ?? "").trim();
  if (!src || !/^https:\/\//i.test(src)) return null;
  const qrUrl = src.replace(/\/?$/, "") + "/qr.svg";
  const en = lang === "en";
  return (
    <div className="sv2-iban-qr is-centered" data-testid="sv2-iban-payment-qr">
      <img
        className="sv2-iban-qr-img"
        data-testid="sv2-iban-qr-img"
        src={qrUrl}
        alt={en ? "NBU IBAN payment QR" : "QR для оплати за IBAN"}
        width={220}
        height={220}
      />
    </div>
  );
}
